export const initialTableSettings = {
  rowHeight: 30,
  maxHeight: 200,
  borderRadius: 10,
  cellFontSize: 11,
  titleRowZIndex: 2,
  titleFontSize: 11,
  tableRowHeight: 30,
  titleRowHeight: 30,
  withTitleRow: true,
  asyncCallback: null,
  useMainColors: true,
  allowEditBtn: false,
  moreBtnCellWidth: 50,
  coloredHeader: false,
  allowSelectAll: false,
  checkBoxCellWidth: 50,
  allowSelectItems: true,
  expandableItems: false,
  coloredActiveRow: false,
  minWidth: 'fit-content',
  asyncChildComponent: false,
  fixLocalLoaderHeight: false,
  getAsyncEndpoint: () => null,
  moreBtnTitleCellAlign: 'normal',
  expandedDetailsComponent: () => null,
  checkBoxCellJustifyContent: 'flex-end',
  moreBtnCellBorderRadius: '0px 10px 10px 0px',
  checkBoxCellBorderRadius: '10px 0px 0px 10px',
};
